import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import onClickOutside from 'react-onclickoutside';
import AccessibilityBlock from './private/AccessibilityBlock';
import config from './private/config';
import appConfig from '../../../../config';

const blocks = Object.keys(config);

class Accessibility extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    router: PropTypes.object,
    setBodyClass: PropTypes.func.isRequired,
  };

  state = {
    color: 'usual',
    buttons: 'usual',
    picture: 'color',
    font: 'arial',
  };

  componentDidMount() {
    document.body.addEventListener('keyup', this.hideOnEscPress);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keyup', this.hideOnEscPress);
  }

  handleClickOutside() {
    this.props.hideModal();
  }

  hideOnEscPress = (e) => {
    if (this.props.showModal && e.key === 'Escape') {
      this.props.hideModal();
    }
  };

  updateBodyClassName() {
    const body = document.getElementsByTagName('body')[0];
    const { color, buttons, picture, font } = this.state;
    const bodyClass = `color-${color} buttons-${buttons} picture-${picture} font-${font}`;
    this.props.setBodyClass(bodyClass);
    body.className = bodyClass;
  }

  handleChange = (type, value) => {
    this.setState({ [type]: value }, () => this.updateBodyClassName());
  };

  render() {
    const { showModal, hideModal } = this.props;

    if (!showModal) {
      return null;
    }

    const versionClasses = classnames('version', {
      version__arm: appConfig.isInspectorArm,
    });

    return (
      <div className={versionClasses}>
        <div className="version_wrapper">
          <div className="content">
            {blocks.map((type) => {
              return (
                <AccessibilityBlock
                  key={`version_block_${type}`}
                  selectedValue={this.state[type]}
                  onChange={this.handleChange}
                  type={type}
                />
              );
            })}

            <div className="version_bottom">
              <a className="link link__20" onClick={hideModal}>
                Закрыть окно
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default onClickOutside(Accessibility);
